import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Search({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'20px'} height={'20px'} viewBox={'0 0 20 20'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-2.000000, -2.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M11,20 C6.02943725,20 2,15.9705627 2,11 C2,6.02943725 6.02943725,2 11,2 C15.9705627,2 20,6.02943725 20,11 C20,15.9705627 15.9705627,20 11,20 Z M11,18 C14.8659932,18 18,14.8659932 18,11 C18,7.13400675 14.8659932,4 11,4 C7.13400675,4 4,7.13400675 4,11 C4,14.8659932 7.13400675,18 11,18 Z M21.7071068,20.2928932 C22.0976311,20.6834175 22.0976311,21.3165825 21.7071068,21.7071068 C21.3165825,22.0976311 20.6834175,22.0976311 20.2928932,21.7071068 L15.9428932,17.3571068 C15.5523689,16.9665825 15.5523689,16.3334175 15.9428932,15.9428932 C16.3334175,15.5523689 16.9665825,15.5523689 17.3571068,15.9428932 L21.7071068,20.2928932 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

Search.propTypes = {
  className: PropTypes.string,
}
